// React libraries
import React from 'react';
import classnames from 'classnames';
// Component Style
import { useStyles } from "./RadioStyles";
export const Radio = (props) => {
    const classes = useStyles(props);
    const { id, type = "n900", name, value, label, disabled = false, style, checked, onChange = () => { } } = props;
    const labelClasses = classnames({
        [classes.label]: true,
        [classes[type]]: type,
        [classes.disabled]: disabled
    });
    return (React.createElement("div", { style: style, id: id },
        React.createElement("input", { type: "radio", className: classes.input, name: name, id: `${name}-${value}`, value: value, disabled: disabled, onChange: onChange, checked: checked }),
        React.createElement("label", { className: labelClasses, htmlFor: `${name}-${value}` }, label)));
};
export default React.memo(Radio);
